import styled from '@emotion/styled';

export const ChooseProjectPageContainer = styled.div`
  background-color: #eff3f6;
  height: 100%;
`;

export const ChooseProjectContainer = styled.div`
  width: 450px;
  border: 2px solid rgba(120, 120, 120, 0.2);
  border-radius: 4px;
  background-color: white;
`;

export const ChooseProjectTopBar = styled.div`
  background: #dce5ed;
  padding: 8px 24px;
`;

export const ChooseProjectFormContainer = styled.div`
  padding: 12px 24px;
`;
